import Routes from "./Routes";

import "./assets/styles/global.scss";
import NotificationProvider from "./providers/NotificationProvider";

// Inicializar o Google Analytics 4

import ReactGA from 'react-ga4';

ReactGA.initialize('G-CK9RG9DXFY');

export default function App() {
  /*useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/", title: "cacadoresdeofertas" });
  }, []);*/

  return (
    <NotificationProvider>


      <Routes />
    </NotificationProvider>


  );
}
